export default __webpack_public_path__ + "bill@2x.f0647268.png";